{
    "raporsatis": {
        "Baslik": "Sales Report",
        "Tarih": "Date",
        "Musteri": "Insured",
        "Urun": "Product",
        "Tutar": "Amount",
        "Kullanici": "User",
        "Durum": "Status",
        "PoliceNo": "Policy No",
        "Aciklama": "Note",
        "IptalTarihi": "Cancel Date",
        "Kur": "Rate",
        "Onayli": "Approved",
        "Onaysiz": "Unapproved",
        "Iptal": "Cancelled",
        "Cayma": "Withdrawal",
        "Toplam": "Total",
        "Adet": "Count",
        "Arama": "Search",
        "Ara": "Search",
        "Kapat": "Close",
        "Temizle": "Clear",
        "BaslangicTarihi": "Start Date",
        "BitisTarihi": "End Date",
        "SatisTipi": "Sales Type",
        "OdemeSekli": "Payment Method",
        "Kapsam": "Scope",
        "Takim": "Team",
        "Sube": "Branch",
        "Istatistikler": "Statistics",
        "OzetGosterge": "Summary Dashboard",
        "ToplamSatisAdedi": "Total Sales Count",
        "ToplamLira": "TL Amount",
        "ToplamDolar": "Dollar Amount",
        "ToplamAPE": "APE Amount",
        "OnayOrani": "Approval Rate",
        "Bekliyor": "Pending",
        "Basari": "Success",
        "Duzenle": "Edit",
        "SigortaEttiren": "Insured Person",
        "Kaydet": "Save",
        "Sil": "Delete",
        "SilmeOnayi": "Delete Confirmation",
        "SilmeMesaji": "Are you sure you want to delete this record?",
        "GeriAlOnayi": "Restore Confirmation",
        "GeriAlMesaji": "Are you sure you want to restore this canceled sale?",
        "DurumOnayi": "Status Change Confirmation",
        "DurumMesaji": "Are you sure you want to change the status of this sale?",
        "Evet": "Yes",
        "Kendi": "Own",
        "Tam": "Full",
        "Hepsi": "All",
        "Yeni": "New",
        "Yenileme": "Renewal",
        "EkBelge": "Endorsement",
        "Pesin": "Cash",
        "Taksitli": "Installment",
        "KrediKarti": "Credit Card",
        "PoliceNoPlaceholder": "Enter policy number",
        "AciklamaPlaceholder": "Add a note...",
        "Network": "Network",
        "Sağlık": "Health",
        "Doğum": "Birth",
        "AktarimTutar": "Transfer Amount (₺)",
        "KalanGunRaporu": "Remaining Days Report",
        "KullaniciListesi": "User List",
        "IptalTarihiSecin": "Select Cancellation Date",
        "TarihSecin": "Select date",
        "Tamam": "OK",
        "IptalGir": "Enter Cancellation",
        "IptalSil": "Remove Cancellation"
    }
}
